import Api from '@/api/api.js'
import constGlobal from '@/utils/constGlobal'
import shareLogo from '@/assets/img/shareLogo.png'
import wx from 'weixin-js-sdk'
import { Base64 } from 'js-base64'

let qs = require('qs')

// 使用 static 目录，路径固定
const shareImageUrl = `${window.location.origin}/static/images/shareLogo.png`

const wxShare = {
  title: '',
  desc: '',
  wxShareInit(title, desc) {
    this.title = title
    this.desc = desc
    if (constGlobal.isWeChat()) {
      this.querySignature(title, desc)
    }
  },
  querySignature(title, desc) {
    let param = {
      url: location.href.split('#')[0]
    }
    Api.getSignature(param).then((res) => {
      if (res.success) {
        wx.config({
          debug: false,
          appId: res.result.appId,
          timestamp: res.result.timestamp,
          nonceStr: res.result.nonceStr,
          signature: res.result.signature,
          jsApiList: [
            'checkJsApi',
            'updateAppMessageShareData',
            'hideOptionMenu',
            'updateTimelineShareData'
          ]
        })
        let url = location.href.split('#')[0]
        // let shareLogo = require('../img/shareLogo.png')
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: [
              'getLocation',
              'updateTimelineShareData',
              'updateAppMessageShareData'
            ],
            success: function(res) { }
          })
          wx.updateAppMessageShareData({
            title: title,
            desc: desc,
            link: url,
            imgUrl: shareImageUrl
          })
          wx.updateTimelineShareData({
            title: title,
            desc: desc,
            link: url,
            imgUrl: shareImageUrl
          })
        })
      }
    })
  }
}

export default {
  install(Vue) {
    Vue.prototype.wxShare = wxShare
  }
}



// WEBPACK FOOTER //
// ./src/utils/wx/wxShare.js